import React from 'react';
import { Helmet } from 'react-helmet';
import { compose } from 'react-apollo';
import { withRouter } from 'react-router';
import { Redirect } from 'react-router-dom';
import { injectIntl, FormattedMessage } from 'react-intl';
import {
  Segment,
  Container,
  Grid,
  Divider,
  Image,
  Header,
} from 'semantic-ui-react';
import injectLayout from 'components/BaseLayout';
// import queryString from 'query-string';
import messages from './messages';

import LogoImg from 'images/logo/bird-colored.svg';
import bg from 'images/above-the-fold-mobile-new-bg.jpg';
import HeroMsg from './HeroMsg';

class AuthPage extends React.Component {
  componentDidMount() {
    sessionStorage.setItem('campaignId', 'signup100');
  }

  render() {
    if (this.props.isLoggedIn) {
      return <Redirect to={{ pathname: '/' }} />;
    }

    const isAr = this.props.intl.locale === 'ar';

    return (
      <div
        style={{
          background: `url(${bg}) 50% 50%/cover no-repeat scroll`,
          minHeight: '100vh',
        }}
      >
        <Helmet>
          <title>{isAr ? 'تسجيل الدخول' : 'Login'}</title>
          <meta
            name="description"
            content={
              isAr
                ? 'تسجيل الدخول إلى حسابك في لينكس. متابعة شحناتك وطلباتك وادارة الحساب الخاص بك.'
                : 'Log in to your Lynks account. check your shipments and requests and manage your account.'
            }
          />
        </Helmet>

        <Container>
          <Divider section hidden />
          <Image src={LogoImg} size="tiny" centered />
          <Divider section hidden />

          <Grid centered stackable>
            <Grid.Column
              tablet={8}
              computer={8}
              largeScreen={6}
              verticalAlign="middle"
            >
              <HeroMsg {...this.props} large />
            </Grid.Column>

            <Grid.Column tablet={8} computer={8} largeScreen={6}>
              <Header size="small" textAlign="center">
                <FormattedMessage {...messages.get100} />
              </Header>
              <Segment>{this.props.children}</Segment>
              <Divider section hidden />
            </Grid.Column>
          </Grid>
        </Container>
      </div>
    );
  }
}

export default compose(withRouter, injectIntl, injectLayout)(AuthPage);



// WEBPACK FOOTER //
// ./app/containers/Auth/AuthPage.js